import React, { useState } from 'react';

import { CtaButton, type CtaButtonProps } from 'components/global/CtaButton';
import { Step, type StepProps } from './components/Step';

import {
  BodyContent,
  Disclaimer,
  Header,
  InnerBox,
  StepsContainer,
  StepsListContainer,
  Subheader,
  desktopCtaStyles,
  mobileCtaStyles,
} from './StepsPop.style';
import { LOCAL_COLORS } from 'styles/constants';

export interface StepsPopProps {
  header?: string;
  subheader?: React.ReactNode;
  steps: StepProps[];
  ctaButton?: CtaButtonProps;
  defaultStep?: number;
  disclaimerText?: string;
  backgroundColor?: string;
}

const moduleName = 'stepsPop';

export const StepsPop = ({
  header,
  subheader,
  steps,
  ctaButton,
  defaultStep = 1,
  disclaimerText,
  backgroundColor = LOCAL_COLORS.surfaceWhite,
}: StepsPopProps) => {
  const [activeStep, setActiveStep] = useState(defaultStep);

  return (
    <StepsContainer data-module={moduleName} backgroundColor={backgroundColor}>
      <InnerBox>
        <BodyContent>
          <div>
            {header && <Header>{header}</Header>}
            {subheader && <Subheader>{subheader}</Subheader>}
          </div>
          {ctaButton && (
            <CtaButton
              color={
                backgroundColor === LOCAL_COLORS.surfaceWhite
                  ? 'primary'
                  : 'dark-blue'
              }
              {...ctaButton}
              css={desktopCtaStyles}
            />
          )}
        </BodyContent>
        <StepsListContainer>
          {steps.map((step, index) => {
            const stepProps = {
              index,
              isActive: index === activeStep,
              setIsActive: (isActive: boolean) =>
                setActiveStep(isActive ? index : defaultStep),
            };

            return <Step key={index} {...step} {...stepProps} />;
          })}
        </StepsListContainer>
        {ctaButton && (
          <CtaButton
            color={
              backgroundColor === LOCAL_COLORS.surfaceWhite
                ? 'primary'
                : 'dark-blue'
            }
            {...ctaButton}
            css={mobileCtaStyles}
          />
        )}
        {disclaimerText && (
          <Disclaimer
            dangerouslySetInnerHTML={{
              __html: disclaimerText,
            }}
          />
        )}
      </InnerBox>
    </StepsContainer>
  );
};
